var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 32,
    fill: "#27272A",
    rx: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Visa_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.394 13.82c-.021 1.666 1.504 2.595 2.652 3.147 1.18.567 1.577.93 1.572 1.437-.009.776-.942 1.118-1.814 1.132-1.523.023-2.408-.406-3.111-.73l-.549 2.532c.706.322 2.014.602 3.37.614 3.182 0 5.264-1.55 5.275-3.955.012-3.05-4.276-3.22-4.246-4.583.01-.413.41-.855 1.285-.967.434-.056 1.631-.1 2.988.517l.533-2.45A8.2 8.2 0 0 0 35.513 10c-2.995 0-5.102 1.572-5.119 3.82m13.073-3.609c-.582 0-1.071.335-1.29.848l-4.546 10.713h3.18l.633-1.726h3.886l.367 1.726H48.5L46.054 10.21zm.444 3.123.918 4.341h-2.513zm-17.373-3.123-2.506 11.56h3.03l2.506-11.56zm-4.482 0L18.9 18.08l-1.275-6.69c-.15-.748-.741-1.179-1.398-1.179h-5.156l-.072.336c1.059.226 2.261.592 2.99.983.446.24.573.448.72 1.016l2.416 9.226h3.202l4.91-11.561z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Visa_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11 10h37.5v12H11z"
  })))));
};
export default SvgVisa;